import { render } from "./CoverMediaPicker.vue?vue&type=template&id=33da1936&scoped=true"
import script from "./CoverMediaPicker.vue?vue&type=script&lang=js"
export * from "./CoverMediaPicker.vue?vue&type=script&lang=js"

import "./CoverMediaPicker.vue?vue&type=style&index=0&id=33da1936&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33da1936"]])

export default __exports__